import { cn } from "@/lib/utils"

interface AnimatedOrbsProps {
  className?: string
}

interface OrbConfig {
  size: string
  top: string
  left: string
  lightColor: string
  darkColor: string
  animationDuration: string
  animationDelay: string
}

const orbs: OrbConfig[] = [
  {
    size: "600px",
    top: "-10%",
    left: "-5%",
    lightColor:
      "radial-gradient(circle, rgba(147,197,253,0.55) 0%, rgba(196,181,253,0.3) 50%, transparent 70%)",
    darkColor:
      "radial-gradient(circle, rgba(99,102,241,0.22) 0%, rgba(139,92,246,0.12) 50%, transparent 70%)",
    animationDuration: "18s",
    animationDelay: "0s",
  },
  {
    size: "500px",
    top: "20%",
    left: "60%",
    lightColor:
      "radial-gradient(circle, rgba(252,165,165,0.45) 0%, rgba(253,186,116,0.25) 50%, transparent 70%)",
    darkColor:
      "radial-gradient(circle, rgba(236,72,153,0.18) 0%, rgba(168,85,247,0.1) 50%, transparent 70%)",
    animationDuration: "22s",
    animationDelay: "-6s",
  },
  {
    size: "450px",
    top: "55%",
    left: "5%",
    lightColor:
      "radial-gradient(circle, rgba(167,243,208,0.5) 0%, rgba(110,231,183,0.28) 50%, transparent 70%)",
    darkColor:
      "radial-gradient(circle, rgba(20,184,166,0.2) 0%, rgba(16,185,129,0.1) 50%, transparent 70%)",
    animationDuration: "26s",
    animationDelay: "-12s",
  },
  {
    size: "520px",
    top: "65%",
    left: "55%",
    lightColor:
      "radial-gradient(circle, rgba(253,224,71,0.38) 0%, rgba(251,191,36,0.2) 50%, transparent 70%)",
    darkColor:
      "radial-gradient(circle, rgba(244,63,94,0.15) 0%, rgba(236,72,153,0.08) 50%, transparent 70%)",
    animationDuration: "20s",
    animationDelay: "-4s",
  },
]

export function AnimatedOrbs({ className }: AnimatedOrbsProps) {
  return (
    <div
      className={cn(
        "fixed inset-0 z-[-1] pointer-events-none overflow-hidden",
        className
      )}
      aria-hidden="true"
    >
      {orbs.map((orb, i) => (
        <div
          key={i}
          className="absolute animate-orb-float"
          style={{
            width: orb.size,
            height: orb.size,
            top: orb.top,
            left: orb.left,
            filter: "blur(80px)",
            animationDuration: orb.animationDuration,
            animationDelay: orb.animationDelay,
          }}
        >
          {/* Light mode orb */}
          <div
            className="absolute inset-0 dark:opacity-0 transition-opacity duration-500"
            style={{ background: orb.lightColor }}
          />
          {/* Dark mode orb */}
          <div
            className="absolute inset-0 opacity-0 dark:opacity-100 transition-opacity duration-500"
            style={{ background: orb.darkColor }}
          />
        </div>
      ))}
    </div>
  )
}
